import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import Table from "../../../core/common/dataTable/index";
import { DatePicker, Drawer, message, Tooltip } from 'antd';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';
import { exportToCSV, exportToExcel, exportToPDF } from '../../../core/common/GlobalFunctions/exportTableData';
import { AppDispatch } from '../../../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllProjects, fetchProjectByEmployeeId } from '../../../core/data/redux/projects/project/projectAction';
import dayjs from 'dayjs';
import { createWorkLog, deleteWorkLog, fetchAllWorkLogs, fetchWorkLogsByEmployeeId, updateWorkLog } from '../../../core/data/redux/attendance/timeworkSheet/timeworkSheetAction';
import { formatDate } from "../../../core/utils/configFormatters";
import { getEmployeeByUserId } from '../../../core/data/redux/employee/employeeAction';
import DeleteModal1 from '../../../core/modals/deleteModal1';
import { filterData } from '../../../core/common/GlobalFunctions/tableFilters';
import { Card } from 'antd';
import { fetchTaskByProjectId } from '../../../core/data/redux/projects/task/taskActions';
import { getTaskByEmployeeId } from '../../../core/data/redux/calendar/calendarAction';
import { useAppConfig } from '../../../customhooks/useAppConfig';
import utc from 'dayjs/plugin/utc';
import { decryptData } from '../../../core/utils/encryptUtils';
import { Modal, Badge, Row, Col, Image } from "react-bootstrap";
dayjs.extend(utc);

const { Meta } = Card;

const TimeSheet = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { projectsData } = useSelector((state: any) => state.project.projects);
  const { projectByEmployeeId } = useSelector((state: any) => state.project.projects);
  const { TaskByProject } = useSelector((state: any) => state.project.task);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const [selectedTaskId, setSelectedTaskId] = useState<any>([]);
  const [projectId, setProjectId] = useState(projectByEmployeeId[0]?.project_id);
  const { employeeTasks } = useSelector((state: any) => state.calendar);
  const [gridData, setGridData] = useState<any[]>([]);
  const [selectedTaskIds, setSelectedTaskIds] = useState<number[]>([]);
  const [timesheetFormData, setTimesheetFormData] = useState({
    deadline: dayjs(),
    total_hours: '',
    remaining_hours: '',
    work_date: dayjs(),
    hours_logged: '',
    status: '',
    description: ''
  });
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState<any>(null);

  const handleWorkedHrsClick = (record: any) => {
    setSelectedDetails(record);
    setIsDetailsModalOpen(true);
  };


  const { workLogs, loading } = useSelector((state: any) => state.attendance.worklog);
  const { worklogsByEmployeeId } = useSelector((state: any) => state.attendance.worklog);
  const workLogAccess = user?.role_name === "Admin" ? workLogs : worklogsByEmployeeId;

  // Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const [validationErrors, setValidationErrors] = useState({
    deadline: dayjs(),
    total_hours: '',
    remaining_hours: '',
    work_date: dayjs(),
    hours_logged: '',
    status: '',
    description: ''
  });

  const defaultFormData = {
    deadline: dayjs(),
    total_hours: '',
    remaining_hours: '',
    work_date: dayjs(),
    hours_logged: '',
    status: '',
    description: ''
  };

  const resetForm = () => {
    setTimesheetFormData(defaultFormData);
    setValidationErrors(defaultFormData);
  };

  const validate = (formData: any) => {
    const errors: any = {};

    if (!formData.total_hours) {
      errors.total_hours = 'Total hours are required';
    } else if (isNaN(Number(formData.total_hours))) {
      errors.total_hours = 'Total hours must be a number';
    }

    if (!formData.remaining_hours) {
      errors.remaining_hours = 'Remaining hours are required';
    } else if (isNaN(Number(formData.remaining_hours))) {
      errors.remaining_hours = 'Remaining hours must be a number';
    }
    const total = Number(formData.total_hours);
    const remaining = Number(formData.remaining_hours);
    if (!isNaN(total) && !isNaN(remaining) && remaining > total) {
      errors.remaining_hours = 'Remaining hours cannot be greater than total hours';
    }

    if (!formData.hours_logged) {
      errors.hours_logged = 'Hours logged are required';
    } else if (isNaN(Number(formData.hours_logged))) {
      errors.hours_logged = 'Hours logged must be a number';
    }
    if (!formData.status) {
      errors.status = 'status is required';
    }

    return errors;
  };

  const handleAddToGrid = () => {
    const errors = validate(timesheetFormData);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    if (!selectedTaskId) {
      message.warning("Please select a Task before adding");
      return;
    }

    const formattedWorkDate = dayjs(timesheetFormData.work_date).format("YYYY-MM-DD");

    // prevent duplicate work_date + task_id
    const duplicate = gridData.some(
      (entry) => entry.work_date === formattedWorkDate && entry.task_id === selectedTaskId
    );
    if (duplicate) {
      message.warning("This task for the selected date already exists in the grid.");
      return;
    }

    const newEntry = {
      ...timesheetFormData,
      deadline: timesheetFormData.deadline ? dayjs(timesheetFormData.deadline).format("YYYY-MM-DD") : null,
      work_date: formattedWorkDate,
      project_id: projectId,
      task_id: selectedTaskId,
      created_by: user.UserId,
      employee_id: employeesbyUser?.employeeId,
      project_name: projectsData.find((p: any) => p.project_id === projectId)?.project_name || "",
      task_name: TaskByProject.find((t: any) => t.task_id === selectedTaskId)?.task_name || "",

    };

    setGridData((prev) => [...prev, newEntry]);
    resetForm();
    message.success("Entry added to grid");
  };

  const handleRowClick = (entry: any) => {
    setTimesheetFormData({
      total_hours: entry.total_hours,
      remaining_hours: entry.remaining_hours,
      deadline: entry.deadline ? dayjs(entry.deadline, "YYYY-MM-DD") : dayjs(),
      work_date: entry.work_date ? dayjs(entry.work_date, "YYYY-MM-DD") : dayjs(),
      hours_logged: entry.hours_logged,
      status: entry.status,
      description: entry.description
    });
    setProjectId(entry.project_id);
    setSelectedTaskId(entry.task_id);
  };


  const employeeId = Number(employeesbyUser?.employeeId);
  useEffect(() => {
    if (employeesbyUser.length === 0) {
      dispatch(getEmployeeByUserId({ userId: user?.UserId }));
    }
    if (projectsData.length === 0) {
      dispatch(fetchAllProjects());
    }

    user?.role_name === "Admin" ? dispatch(fetchAllWorkLogs()) : dispatch(fetchWorkLogsByEmployeeId(employeeId));

    if (employeeId) {
      dispatch(getTaskByEmployeeId(employeeId))
    }
    if (employeeId) dispatch(fetchProjectByEmployeeId({ employeeId }));
  }, [dispatch, user?.UserId, employeesbyUser.length, projectsData.length, workLogs.length, employeeId, user?.role_name]);

  useEffect(() => {
    if (projectId) {
      dispatch(fetchTaskByProjectId(projectId));
    }
  }, [projectId, dispatch]);

  const showModal = (type: 'edit' | 'create') => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType('');
    resetForm();
  };

  const handleInputChange = (e: any, field: string) => {
    const { value } = e.target;
    setTimesheetFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
    const updatedValidationErrors = validate({ ...timesheetFormData, [field]: value });
    setValidationErrors(updatedValidationErrors);
  };


  const handleEditTImesheet = (record: any): void => {
    setSelectedRowData(record);

    // Pre-fill the first detail in form (optional)
    const firstDetail = record.details?.[0] || {};

    setTimesheetFormData({
      total_hours: firstDetail.total_hours || '',
      remaining_hours: firstDetail.remaining_hours || '',
      deadline: firstDetail.deadline ? dayjs(firstDetail.deadline, "YYYY-MM-DD").utc(true) : dayjs(),
      work_date: firstDetail.work_date ? dayjs(firstDetail.work_date, "YYYY-MM-DD").utc(true) : dayjs(),
      hours_logged: firstDetail.hours_logged || '',
      status: firstDetail.status || '',
      description: firstDetail.description || ''
    });

    // Preload all entries in the grid
    const formattedGridData = (record.details || []).map((d: any) => ({
      ...d,
      deadline: d.deadline ? dayjs(d.deadline).format("YYYY-MM-DD") : null,
      work_date: d.work_date ? dayjs(d.work_date).format("YYYY-MM-DD") : null,
      total_hours: d.total_hours,
      remaining_hours: d.remaining_hours,
      hours_logged: d.hours_logged,
      status: d.status,
      description: d.description,
      project_id: d.project_id,
      task_id: d.task_id,
      project_name: d.project_name,
      task_name: d.task_name,
    }));

    setGridData(formattedGridData);

    // Optionally select the first project/task
    if (formattedGridData.length > 0) {
      setProjectId(formattedGridData[0].project_id);
      setSelectedTaskId(formattedGridData[0].task_id);
    }

    showModal('edit');
  };


  const handleSubmit = async () => {
    const entriesToSave = gridData.length > 0 ? gridData : [timesheetFormData];

    for (const entry of entriesToSave) {
      const errors = validate(entry);
      if (Object.keys(errors).length > 0) {
        setValidationErrors(errors);
        return;
      }

      const formattedData = {
        ...entry,
        deadline: entry.deadline ? dayjs(entry.deadline).format("YYYY-MM-DD") : null,
        work_date: entry.work_date ? dayjs(entry.work_date).format("YYYY-MM-DD") : null,
        project_id: entry.project_id || projectId,
        task_id: entry.task_id || JSON.stringify(selectedTaskIds),
        created_by: user.UserId,
        employee_id: employeesbyUser?.employeeId,
      };

      try {
        const result = await dispatch(createWorkLog(formattedData)).unwrap();
        if (result) {
          message.success(`Saved entry for ${formattedData.work_date}`);
        }
      } catch (error) {
        message.error(`Failed to save entry for ${formattedData.work_date}`);
      }
    }

    await dispatch(fetchAllWorkLogs());
    setTableKey((prevKey) => prevKey + 1);
    setGridData([]);
    handleCancel();
  };


  const handleDeleteWorklog = async (workId: number) => {
    try {
      const result = await dispatch(deleteWorkLog({ workId }));
      if (result.meta.requestStatus === 'fulfilled') {
        alert('Deleted successfully');
        await dispatch(fetchAllWorkLogs());
        setTableKey((prevKey) => prevKey + 1);
        setIsDeleteModalVisible(false);
      } else {
        alert(result.payload.error);
      }
    } catch (error) {
      alert('Something went wrong');
    }
  };
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'High':
        return '#e74c3c';
      case 'Medium':
        return '#f39c12';
      case 'Low':
        return '#2ecc71';
      default:
        return '#7f8c8d';
    }
  };

  const data = workLogAccess ? workLogAccess : [];
  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { status: selectedStatus }
        : {};
    return filterData(data || [], filters, "created_at", "created_at", selectedSort);
  }, [selectedStatus, data, selectedSort]);

  useEffect(() => {
    setTableKey(prevKey => prevKey + 1);
  }, [selectedStatus, selectedSort, data]);

  const config = useAppConfig();
  if (!config) return null;


  const exportTimeSheet = data.map((item: any) => ({
    employee_name: item.employee_name || "N/A",
    project_name: item.project_name || "N/A",
    total_hours: item.total_hours || 0,
    remaining_hours: item.remaining_hours || 0,
    hours_logged: item.hours_logged || 0,
    status: item.status || "N/A",
    deadline: item.deadline ? formatDate(item.deadline, config) : "N/A",
    work_date: item.work_date ? formatDate(item.work_date, config) : "N/A",
    created_at: item.created_at ? formatDate(item.created_at, config) : "N/A",
    modified_at: item.modified_at ? formatDate(item.modified_at, config) : "N/A",
  }));

  const isOlderThan7Days = (modifiedAt: string) => {
    if (!modifiedAt) return true; // if no modified date, show by default

    const modifiedDate = new Date(modifiedAt);
    const today = new Date();

    // calculate difference in ms
    const diffMs = today.getTime() - modifiedDate.getTime();

    // convert ms → days
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    return diffDays > 7;
  };


  const columns = [
    {
      title: "Employee",
      dataIndex: "employee_name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="avatar avatar-md">
            <img src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="img" className='img-fluid rounded-circle' />
          </div>
          <div className="ms-2">
            <h6 className="fw-medium">
              <div>{record.employee_name}</div>
            </h6>
            {/* <span className="fs-12 fw-normal ">{record.Role}</span> */}
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.employee_name.length - b.employee_name.length,
    },
    {
      title: "Tasks",
      dataIndex: "task_names",
      sorter: (a: any, b: any) => a.task_names.length - b.task_names.length,
    },
    {
      title: "Projects",
      dataIndex: "project_names",
      sorter: (a: any, b: any) => a.project_names.length - b.project_names.length,
    },
    {
      title: "Date",
      dataIndex: "work_date",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.work_date.length - b.work_date.length,
    },
    {
      title: "Assigned hours",
      dataIndex: "total_hours",
      sorter: (a: any, b: any) => a.total_hours.length - b.total_hours.length,
    },
    {
      title: 'Worked Hrs',
      dataIndex: 'hours_logged',
      key: 'hours_logged',
      render: (text: any, record: any) => (
        <span
          onClick={() => handleWorkedHrsClick(record)}
          style={{
            color: '#1890ff',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "deadline",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.deadline.length - b.deadline.length,
    },
    {
      title: "Request Status",
      dataIndex: "requestStatus",
      render: (text: string, record: any) => {
        let badgeClass = '';
        let badgeText = '';
        switch (text) {
          case 'Pending':
            badgeClass = 'badge-warning';
            badgeText = 'Pending';
            break;
          case 'Approved':
            badgeClass = 'badge-success';
            badgeText = 'Approved';
            break;
          case 'Rejected':
            badgeClass = 'badge-danger';
            badgeText = 'Rejected';
            break;
          default:
            badgeClass = 'badge-secondary';
            badgeText = 'Unknown';
        }

        return (
          <span className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}>
            <i className="ti ti-point-filled me-1" />
            {badgeText}
          </span>
        );
      },
    },
    {
      title: "Task Status",
      dataIndex: "status",
      render: (text: string, record: any) => {
        let badgeClass = '';
        let badgeText = '';
        switch (text) {
          case 'Pending':
            badgeClass = 'badge-warning';
            badgeText = 'Pending';
            break;
          case 'In Progress':
            badgeClass = 'badge-primary';
            badgeText = 'In Progress';
            break;
          case 'Completed':
            badgeClass = 'badge-success';
            badgeText = 'Completed';
            break;
          case 'Deleted':
            badgeClass = 'badge-danger';
            badgeText = 'Deleted';
            break;
          default:
            badgeClass = 'badge-secondary';
            badgeText = 'Unknown';
        }

        return (
          <span className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}>
            <i className="ti ti-point-filled me-1" />
            {badgeText}
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isApproved = record.requestStatus === 'Approved';

        return (
          <div className="action-icon d-inline-flex">
            <button
              className="me-2"
              onClick={() => {
                if (!canEdit || isApproved) return;
                showModal("edit");
                handleEditTImesheet(record);
              }}
              disabled={!canEdit || isApproved}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                !canEdit
                  ? "Permission Denied"
                  : isApproved
                    ? "Already Approved - Cannot Edit"
                    : "Edit Timesheet"
              }
            >
              <i className="ti ti-edit" />
            </button>

            <button
              onClick={() => {
                if (!canDelete || isApproved) return;
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
              className="me-2"
              disabled={!canDelete || isApproved}
              style={{
                cursor: !canDelete || isApproved ? "not-allowed" : "pointer",
                opacity: !canDelete || isApproved ? 0.5 : 1,
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                !canDelete
                  ? "Permission Denied"
                  : isApproved
                    ? "Already Approved - Cannot Delete"
                    : "Delete Timesheet"
              }
            >
              <i className="ti ti-trash" />
            </button>

          </div>
        );
      }
    },
  ]


  const getModalContainer = () => {
    const modalElement = document.getElementById('modal-datepicker');
    return modalElement ? modalElement : document.body;
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Timesheets</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Timesheets
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportTimeSheet, 'timesheet_data')}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportTimeSheet, 'timesheet_data')}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportTimeSheet, 'timesheet_data')}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button onClick={() => showModal('create')} className="btn btn-primary d-flex align-items-center">
                    <i className="ti ti-circle-plus me-2" />
                    Add Today’s Work
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* filterlist need to put here */}

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Timesheet</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus ? selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1) : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Pending')}
                        className="dropdown-item rounded-1"
                      >
                        Pending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('In Progress')}
                        className="dropdown-item rounded-1"
                      >
                        In Progress
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Completed')}
                        className="dropdown-item rounded-1"
                      >
                        Completed
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Deleted')}
                        className="dropdown-item rounded-1"
                      >
                        Deleted
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Recently Added")} className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Ascending")} className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Descending")} className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Last Month")} className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Last 7 Days")} className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table key={tableKey} dataSource={filteredData} columns={columns} Selection={true} />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Timesheet */}
      <Drawer
        title={modalType === "edit" ? "Edit Todays Work" : "Add Todays Work"}
        placement="right"
        width={750}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="modal-body pb-0">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', padding: '10px' }}>
                    <Row gutter={[12, 12]} justify="center">
                      {projectByEmployeeId?.map((project: any) => (
                        <Col span={7} key={project.project_id} onClick={() => setProjectId(project.project_id)}>
                          <Card
                            hoverable
                            style={{
                              backgroundColor: '#ffffff',
                              borderRadius: '8px',
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                              border: projectId === project.project_id ? '2px solid #1890ff' : '1px solid #f0f0f0',
                              transform: projectId === project.project_id ? 'scale(1.03)' : 'scale(1)',
                              cursor: 'pointer',
                            }}
                            cover={
                              <div
                                style={{
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #e6f7ff, #bae7ff)',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  borderRadius: '8px 8px 0 0',
                                  borderBottom: '1px solid #f0f0f0',
                                }}
                              >
                                <strong style={{ fontSize: '20px', color: '#003a8c' }}>
                                  {project.project_name}
                                </strong>
                              </div>
                            }
                          >
                            <Meta
                              description={
                                <div style={{ padding: '2px 0', color: '#595959' }}>
                                  <p style={{ marginBottom: 6 }}>
                                    <strong style={{ color: '#262626' }}>Manager:</strong>{' '}
                                    <Tooltip title={project.project_manager_name}>
                                      <span style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'inline-block', maxWidth: '150px', verticalAlign: 'bottom' }}>
                                        {project.project_manager_name.split(' ')[0]}
                                      </span>
                                    </Tooltip>
                                  </p>
                                  <p style={{ marginBottom: 6 }}>
                                    <strong style={{ color: '#262626' }}>Priority:</strong> {project.priority}
                                  </p>
                                  <p style={{ marginBottom: 0 }}>
                                    <strong style={{ color: '#262626' }}>Status:</strong> {project.status}
                                  </p>
                                </div>
                              }
                            />
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className='col-md-5 card me-3 p-2' style={{ backgroundColor: '#f0f0f0' }}>
                {TaskByProject && TaskByProject.length > 0 ? (
                  TaskByProject
                    .filter((task: any) => isOlderThan7Days(task.ModifiedAt))
                    .map((task: any, index: number) => {
                      const isSelected = selectedTaskIds.includes(task.TaskID);
                      return (
                        <div
                          key={task.TaskID}
                          className="card me-3 p-3 mb-3"
                          style={{
                            backgroundColor: isSelected ? '#e6f7ff' : '#f8f9fa',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            border: isSelected ? '2px solid #007bff' : '1px solid #ddd',
                            transform: isSelected ? 'scale(1.03)' : 'scale(1)',
                            transition: 'transform 0.3s ease, border 0.3s ease',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setSelectedTaskIds((prev) =>
                              prev.includes(task.TaskID)
                                ? prev.filter((id) => id !== task.TaskID)
                                : [...prev, task.TaskID]
                            );

                            setSelectedTaskId(task.TaskID);
                          }}

                        >
                          <div>
                            <h5 style={{ fontWeight: 'bold', color: '#333' }}>Task #{index + 1}</h5>
                            <div className='d-flex justify-content-between align-items-center'>
                              <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>
                                <strong>Title:</strong> {task.Title}
                              </p>
                              <p
                                style={{
                                  fontSize: '1rem',
                                  fontWeight: '500',
                                  padding: '0.5rem 1rem',
                                  borderRadius: '20px',
                                  backgroundColor: getPriorityColor(task.Priority),
                                  color: 'white',
                                  textTransform: 'capitalize',
                                }}
                              >
                                {task.Priority}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div className="text-center text-danger fw-bold mt-4 mb-3">
                    No task found. Kindly create a task.
                  </div>
                )}
              </div>
              <div className='col-md-6 card p-2' style={{ backgroundColor: '#f0f0f0' }}>
                <div className="mb-3">
                  <label className="form-label">
                    Deadline <span className="text-danger"> *</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      format="DD-MM-YYYY"
                      getPopupContainer={getModalContainer}
                      value={timesheetFormData.deadline ? dayjs(timesheetFormData.deadline).utc(true) : null}
                      onChange={(date) => setTimesheetFormData({ ...timesheetFormData, deadline: date })}
                      placeholder="DD-MM-YYYY"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Total Hours <span className="text-danger"> *</span>
                  </label>
                  <input type="text" className="form-control" value={timesheetFormData.total_hours} onChange={(e) => handleInputChange(e, 'total_hours')} />
                  {validationErrors.total_hours && (
                    <div className="text-danger" style={{ fontSize: '12px' }}>
                      {validationErrors.total_hours}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Remaining Hours<span className="text-danger"> *</span>
                  </label>
                  <input type="text" className="form-control" value={timesheetFormData.remaining_hours} onChange={(e) => handleInputChange(e, 'remaining_hours')} />
                  {validationErrors.remaining_hours && (
                    <div className="text-danger" style={{ fontSize: '12px' }}>
                      {validationErrors.remaining_hours}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Date<span className="text-danger"> *</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      format="DD-MM-YYYY"
                      getPopupContainer={getModalContainer}
                      value={timesheetFormData.work_date ? dayjs(timesheetFormData.work_date).utc(true) : null}
                      onChange={(date) => setTimesheetFormData({ ...timesheetFormData, work_date: date })}
                      placeholder="DD-MM-YYYY"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Hours<span className="text-danger"> *</span>
                  </label>
                  <input type="text" className="form-control" value={timesheetFormData.hours_logged} onChange={(e) => handleInputChange(e, 'hours_logged')} />
                  {validationErrors.hours_logged && (
                    <div className="text-danger" style={{ fontSize: '12px' }}>
                      {validationErrors.hours_logged}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Status<span className="text-danger"> *</span>
                  </label>
                  <select className="form-control" value={timesheetFormData.status} onChange={(e) => handleInputChange(e, 'status')}>
                    <option value="">Select</option>
                    <option value="Pending">Pending</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Completed">Completed</option>
                    <option value="Deleted">Deleted</option>
                  </select>

                  {validationErrors.status && (
                    <div className="text-danger" style={{ fontSize: '12px' }}>
                      {validationErrors.status}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Description
                  </label>
                  <input type="text" className="form-control" value={timesheetFormData.description} onChange={(e) => handleInputChange(e, 'description')} />
                </div>
              </div>
            </div>
          </div>

          {gridData.length > 0 && (
            <div className="mt-4">
              <h5>Entries to be Saved</h5>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Work Date</th>
                      <th>Project Name</th>
                      <th>Task Name</th>
                      <th>Deadline</th>
                      <th>Total Hours</th>
                      <th>Remaining Hours</th>
                      <th>Hours Logged</th>
                      <th>Status</th>
                      <th>Description</th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridData.map((entry, index) => (
                      <tr
                        key={index}
                        onClick={() => handleRowClick(entry)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td>{index + 1}</td>
                        <td>{entry.work_date}</td>
                        <td>{entry.project_name}</td>   {/* ✅ */}
                        <td>{entry.task_name}</td>
                        <td>{entry.deadline}</td>
                        <td>{entry.total_hours}</td>
                        <td>{entry.remaining_hours}</td>
                        <td>{entry.hours_logged}</td>
                        <td>{entry.status}</td>
                        <td>{entry.description}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => {
                              e.stopPropagation();
                              setGridData(gridData.filter((_, i) => i !== index));
                            }}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            </div>
          )}


          {employeeTasks && employeeTasks.length > 0 && (
            <>
              <h5 className="mt-4 mb-2">Meeting Time</h5>
              <div style={{ overflowX: 'auto', width: '100%' }}>
                <table className="table table-bordered table-striped" style={{ minWidth: '800px' }}>
                  <thead>
                    <tr>
                      <th>Task Name</th>
                      <th>Description</th>
                      <th>Mode</th>
                      <th>Trainer Type</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Total Time (hh:mm:ss)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeTasks
                      .filter((task: any) => {
                        const taskDate = new Date(task?.StartDate).toLocaleDateString('en-CA');
                        const selectedDate = timesheetFormData.work_date?.format('YYYY-MM-DD');
                        return taskDate === selectedDate;
                      })
                      .map((task: any) => {
                        const start = new Date(task?.StartDate);
                        const end = new Date(task?.EndDate);
                        const totalTimeMs = end.getTime() - start.getTime();
                        const totalHours = Math.floor(totalTimeMs / (1000 * 60 * 60));
                        const totalMinutes = Math.floor((totalTimeMs % (1000 * 60 * 60)) / (1000 * 60));
                        const totalSeconds = Math.floor((totalTimeMs % (1000 * 60)) / 1000);
                        const totalTimeFormatted = `${String(totalHours).padStart(2, '0')}:${String(totalMinutes).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`;

                        return (
                          <tr key={task?.id}>
                            <td>{task?.Name}</td>
                            <td>{task?.Description}</td>
                            <td>{task?.Mode}</td>
                            <td>{task?.Trainertype}</td>
                            <td>{start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</td>
                            <td>{end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</td>
                            <td>{totalTimeFormatted}</td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div className="modal-footer mt-2">
            <button type="button" className="btn btn-light me-2" onClick={handleCancel}>Cancel</button>

            <button type="button" className="btn btn-success me-2" onClick={handleAddToGrid}>
              Add
            </button>

            <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {modalType === 'edit' ? 'Updating...' : 'Saving...'}
                </>
              ) : (
                modalType === 'edit' ? 'Update' : 'Save'
              )}
            </button>
          </div>

        </form>
      </Drawer>

      <Modal
        show={isDetailsModalOpen}
        onHide={() => setIsDetailsModalOpen(false)}
        centered
        size="lg"
      >
        {selectedDetails && (
          <>
            <Modal.Header closeButton>
              <div className="d-flex align-items-center">
                <div>
                  <h5 className="mb-0">{selectedDetails.employee_name}</h5>
                  <small className="text-muted">
                    Date:{" "}
                    {new Date(selectedDetails.work_date).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </small>
                </div>
              </div>
            </Modal.Header>

            <Modal.Body
              style={{
                maxHeight: "60vh",
                overflowY: "auto",
                backgroundColor: "#f9fafb",
              }}
            >
              {selectedDetails.details && selectedDetails.details.length > 0 ? (
                selectedDetails.details.map((item: any, index: number) => (
                  <Card
                    key={item.work_id}
                    className="mb-3 shadow-sm border-0"
                    style={{ borderRadius: "12px" }}
                  >
                    <Card>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">
                          #{index + 1} — {item.task_name || "Untitled Task"}
                        </h6>
                        <Badge
                          bg={
                            item.requestStatus === "Approved"
                              ? "success"
                              : item.requestStatus === "Rejected"
                                ? "danger"
                                : "warning"
                          }
                          className="px-3 py-2 text-white"
                          style={{ borderRadius: "20px" }}
                        >
                          {item.requestStatus}
                        </Badge>
                      </div>

                      <Row className="mb-2">
                        <Col xs={12} md={6}>
                          <strong>Project:</strong> {item.project_name || "N/A"}
                        </Col>
                        <Col xs={12} md={6}>
                          <strong>Priority:</strong> {item.priority || "—"}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col>
                          <strong>Description:</strong> {item.description || "—"}
                        </Col>
                      </Row>

                      <Row className="text-center mb-3">
                        <Col>
                          <div
                            className="p-2 bg-light rounded"
                            style={{ minHeight: "60px" }}
                          >
                            <small className="text-muted">Hours Logged</small>
                            <div className="fw-semibold">{item.hours_logged}</div>
                          </div>
                        </Col>
                        <Col>
                          <div
                            className="p-2 bg-light rounded"
                            style={{ minHeight: "60px" }}
                          >
                            <small className="text-muted">Total Hours</small>
                            <div className="fw-semibold">{item.total_hours}</div>
                          </div>
                        </Col>
                        <Col>
                          <div
                            className="p-2 bg-light rounded"
                            style={{ minHeight: "60px" }}
                          >
                            <small className="text-muted">Remaining</small>
                            <div className="fw-semibold">{item.remaining_hours}</div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="text-center">
                        <Col>
                          <div className="p-2 bg-light rounded">
                            <small className="text-muted">Status</small>
                            <div className="fw-semibold">{item.status}</div>
                          </div>
                        </Col>
                        <Col>
                          <div className="p-2 bg-light rounded">
                            <small className="text-muted">Deadline</small>
                            <div className="fw-semibold">
                              {new Date(item.deadline).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </Card>
                ))
              ) : (
                <div className="text-center text-muted py-4">
                  No work details found.
                </div>
              )}
            </Modal.Body>
          </>
        )}
      </Modal>;


      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedRowData?.work_id && handleDeleteWorklog(selectedRowData.work_id)}
      />
      {/* /Add Timesheet */}
    </>
  )
}

export default TimeSheet
